<template>
  <div class="single-warning mb-3 mt-0">
    <div class="title cursor-pointer" @click="showModal = true">
      <b-icon-exclamation-circle-fill class="icon-svg" font-scale="0.84" />
      {{ warning.title }}
      <b-icon-arrow-right-short
        class="float-right lead d-block d-md-none icon-svg"
        font-scale="1.8"
      />
    </div>
    <div
      class="message d-none d-md-block"
      v-html="parseMarkdown(warning.subtext)"
    ></div>
    <div class="alert-cta d-none d-md-block">
      <b-button
        variant="white"
        size="lg"
        @click="showModal = true"
        v-track-click
        id="invoices-alerts-docs-pending"
      >
        {{ warning.button }}
      </b-button>
    </div>
    <b-modal
      id="warning-modal"
      class="warning-modal"
      v-model="showModal"
      size="md"
      centered
      okVariant="primary"
      ok-only
      :title="warning.title"
    >
      <div class="desc" v-html="parseMarkdown(warning.desc)"></div>
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showModal: false
    }
  },
  props: {
    warning: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    parseMarkdown(markdownText) {
      const htmlText = markdownText
        .replace(/__(.+?)__/gim, '<b>$1</b>')
        .replace(/\*(.*)\*/gim, '<i>$1</i>')
      return htmlText.trim()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/variables';
.single-warning {
  border-radius: $border-radius;
  background: $dc-warning-bg-color;
  border: 1px solid $warning;
  border-left-width: 3px;
  padding: 1.2rem;
  box-shadow: $box-shadow-sm;
  margin-bottom: 1rem;
  font-family: $montserrat;
  .title {
    font-size: 1rem;
    font-weight: 600;
    color: $warning;
    .icon-svg {
      margin-bottom: 1px;
    }
  }
  .message {
    flex-grow: 1;
    font-size: 1rem;
    line-height: 1.85rem;
    align-items: center;
    font-family: $lato;
    margin: 1rem 0;
  }
  .alert-cta {
    .btn {
      background: $warning;
      color: white;
      font-size: 1rem;
      width: 100%;
    }
  }
  &:last-child {
    margin-bottom: 0;
  }
}
.warning-modal {
  .desc {
    line-height: 2;
  }
}
</style>
